import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _f97f5cf4 = () => interopDefault(import('../src/pages/account/index.vue' /* webpackChunkName: "pages/account/index" */))
const _42e95f05 = () => interopDefault(import('../src/pages/auth/index.vue' /* webpackChunkName: "pages/auth/index" */))
const _79f7e60e = () => interopDefault(import('../src/pages/categories/index.vue' /* webpackChunkName: "pages/categories/index" */))
const _49a803ae = () => interopDefault(import('../src/pages/change-password.vue' /* webpackChunkName: "pages/change-password" */))
const _0ac509c6 = () => interopDefault(import('../src/pages/deals.vue' /* webpackChunkName: "pages/deals" */))
const _4dc9271b = () => interopDefault(import('../src/pages/forgot-password.vue' /* webpackChunkName: "pages/forgot-password" */))
const _bd26366c = () => interopDefault(import('../src/pages/gift-guides.vue' /* webpackChunkName: "pages/gift-guides" */))
const _276885b9 = () => interopDefault(import('../src/pages/home.vue' /* webpackChunkName: "pages/home" */))
const _3743c508 = () => interopDefault(import('../src/pages/home/index.vue' /* webpackChunkName: "pages/home/index" */))
const _59da64fe = () => interopDefault(import('../src/pages/home/following/index.vue' /* webpackChunkName: "pages/home/following/index" */))
const _fdf11676 = () => interopDefault(import('../src/pages/home/for-you.vue' /* webpackChunkName: "pages/home/for-you" */))
const _d88329aa = () => interopDefault(import('../src/pages/home/following/giftguides.vue' /* webpackChunkName: "pages/home/following/giftguides" */))
const _38e5d002 = () => interopDefault(import('../src/pages/login.vue' /* webpackChunkName: "pages/login" */))
const _49b21f38 = () => interopDefault(import('../src/pages/logout.vue' /* webpackChunkName: "pages/logout" */))
const _895fc548 = () => interopDefault(import('../src/pages/ltk-chat.vue' /* webpackChunkName: "pages/ltk-chat" */))
const _27953840 = () => interopDefault(import('../src/pages/ltk-shopping-app.vue' /* webpackChunkName: "pages/ltk-shopping-app" */))
const _62effcfc = () => interopDefault(import('../src/pages/search.vue' /* webpackChunkName: "pages/search" */))
const _4b20561c = () => interopDefault(import('../src/pages/signup.vue' /* webpackChunkName: "pages/signup" */))
const _d25eb06a = () => interopDefault(import('../src/pages/sitemap.vue' /* webpackChunkName: "pages/sitemap" */))
const _be5178c2 = () => interopDefault(import('../src/pages/terms-of-service.vue' /* webpackChunkName: "pages/terms-of-service" */))
const _302b7b38 = () => interopDefault(import('../src/pages/wishlists.vue' /* webpackChunkName: "pages/wishlists" */))
const _3f648cce = () => interopDefault(import('../src/pages/account/favorites/index.vue' /* webpackChunkName: "pages/account/favorites/index" */))
const _71401236 = () => interopDefault(import('../src/pages/auth/callback/index.vue' /* webpackChunkName: "pages/auth/callback/index" */))
const _312fb64a = () => interopDefault(import('../src/pages/creators/matching.vue' /* webpackChunkName: "pages/creators/matching" */))
const _cc42d64c = () => interopDefault(import('../src/pages/legal/virtual-patent.vue' /* webpackChunkName: "pages/legal/virtual-patent" */))
const _30171162 = () => interopDefault(import('../src/pages/account/favorites/posts.vue' /* webpackChunkName: "pages/account/favorites/posts" */))
const _42d8fd18 = () => interopDefault(import('../src/pages/account/favorites/products.vue' /* webpackChunkName: "pages/account/favorites/products" */))
const _19e574e8 = () => interopDefault(import('../src/pages/index.vue' /* webpackChunkName: "pages/index" */))
const _5e6d57a8 = () => interopDefault(import('../src/pages/auth/reconsent/_connection.vue' /* webpackChunkName: "pages/auth/reconsent/_connection" */))
const _24f194f8 = () => interopDefault(import('../src/pages/categories/_category.vue' /* webpackChunkName: "pages/categories/_category" */))
const _2fc1a789 = () => interopDefault(import('../src/pages/collections/_hash.vue' /* webpackChunkName: "pages/collections/_hash" */))
const _76515587 = () => interopDefault(import('../src/pages/explore/_displayName/index.vue' /* webpackChunkName: "pages/explore/_displayName/index" */))
const _2a9f770b = () => interopDefault(import('../src/pages/hashtags/_hashtag.vue' /* webpackChunkName: "pages/hashtags/_hashtag" */))
const _6c54bcb6 = () => interopDefault(import('../src/pages/post/_id.vue' /* webpackChunkName: "pages/post/_id" */))
const _e9a4b52e = () => interopDefault(import('../src/pages/products/_id.vue' /* webpackChunkName: "pages/products/_id" */))
const _b3f80384 = () => interopDefault(import('../src/pages/user/_invite.vue' /* webpackChunkName: "pages/user/_invite" */))
const _4dd96376 = () => interopDefault(import('../src/pages/explore/_displayName/chat/index.vue' /* webpackChunkName: "pages/explore/_displayName/chat/index" */))
const _633b73e6 = () => interopDefault(import('../src/pages/explore/_displayName/collections/index.vue' /* webpackChunkName: "pages/explore/_displayName/collections/index" */))
const _75419576 = () => interopDefault(import('../src/pages/explore/_displayName/giftguides/index.vue' /* webpackChunkName: "pages/explore/_displayName/giftguides/index" */))
const _27cfb478 = () => interopDefault(import('../src/pages/explore/_displayName/productsets/index.vue' /* webpackChunkName: "pages/explore/_displayName/productsets/index" */))
const _49f467b5 = () => interopDefault(import('../src/pages/explore/_displayName/collections/_id.vue' /* webpackChunkName: "pages/explore/_displayName/collections/_id" */))
const _1b53c4ed = () => interopDefault(import('../src/pages/explore/_displayName/giftguides/_id.vue' /* webpackChunkName: "pages/explore/_displayName/giftguides/_id" */))
const _8cc10414 = () => interopDefault(import('../src/pages/explore/_displayName/posts/_id/index.vue' /* webpackChunkName: "pages/explore/_displayName/posts/_id/index" */))
const _7b9f1640 = () => interopDefault(import('../src/pages/explore/_displayName/productsets/_id.vue' /* webpackChunkName: "pages/explore/_displayName/productsets/_id" */))
const _05fd54d4 = () => interopDefault(import('../src/pages/explore/_displayName/giftguides/_giftGuides/_product.vue' /* webpackChunkName: "pages/explore/_displayName/giftguides/_giftGuides/_product" */))
const _ef84ca52 = () => interopDefault(import('../src/pages/explore/_displayName/productsets/_productSet/_product.vue' /* webpackChunkName: "pages/explore/_displayName/productsets/_productSet/_product" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/account",
    component: _f97f5cf4,
    name: "account"
  }, {
    path: "/auth",
    component: _42e95f05,
    name: "auth"
  }, {
    path: "/categories",
    component: _79f7e60e,
    name: "categories"
  }, {
    path: "/change-password",
    component: _49a803ae,
    name: "change-password"
  }, {
    path: "/deals",
    component: _0ac509c6,
    name: "deals"
  }, {
    path: "/forgot-password",
    component: _4dc9271b,
    name: "forgot-password"
  }, {
    path: "/gift-guides",
    component: _bd26366c,
    name: "gift-guides"
  }, {
    path: "/home",
    component: _276885b9,
    children: [{
      path: "",
      component: _3743c508,
      name: "home"
    }, {
      path: "following",
      component: _59da64fe,
      name: "home-following"
    }, {
      path: "for-you",
      component: _fdf11676,
      name: "home-for-you"
    }, {
      path: "following/giftguides",
      component: _d88329aa,
      name: "home-following-giftguides"
    }]
  }, {
    path: "/login",
    component: _38e5d002,
    name: "login"
  }, {
    path: "/logout",
    component: _49b21f38,
    name: "logout"
  }, {
    path: "/ltk-chat",
    component: _895fc548,
    name: "ltk-chat"
  }, {
    path: "/ltk-shopping-app",
    component: _27953840,
    name: "ltk-shopping-app"
  }, {
    path: "/search",
    component: _62effcfc,
    name: "search"
  }, {
    path: "/signup",
    component: _4b20561c,
    name: "signup"
  }, {
    path: "/sitemap",
    component: _d25eb06a,
    name: "sitemap"
  }, {
    path: "/terms-of-service",
    component: _be5178c2,
    name: "terms-of-service"
  }, {
    path: "/wishlists",
    component: _302b7b38,
    name: "wishlists"
  }, {
    path: "/account/favorites",
    component: _3f648cce,
    name: "account-favorites"
  }, {
    path: "/auth/callback",
    component: _71401236,
    name: "auth-callback"
  }, {
    path: "/creators/matching",
    component: _312fb64a,
    name: "creators-matching"
  }, {
    path: "/legal/virtual-patent",
    component: _cc42d64c,
    name: "legal-virtual-patent"
  }, {
    path: "/account/favorites/posts",
    component: _30171162,
    name: "account-favorites-posts"
  }, {
    path: "/account/favorites/products",
    component: _42d8fd18,
    name: "account-favorites-products"
  }, {
    path: "/",
    component: _19e574e8,
    name: "index"
  }, {
    path: "/auth/reconsent/:connection?",
    component: _5e6d57a8,
    name: "auth-reconsent-connection"
  }, {
    path: "/categories/:category",
    component: _24f194f8,
    name: "categories-category"
  }, {
    path: "/collections/:hash?",
    component: _2fc1a789,
    name: "collections-hash"
  }, {
    path: "/explore/:displayName",
    component: _76515587,
    name: "explore-displayName"
  }, {
    path: "/hashtags/:hashtag?",
    component: _2a9f770b,
    name: "hashtags-hashtag"
  }, {
    path: "/post/:id?",
    component: _6c54bcb6,
    name: "post-id"
  }, {
    path: "/products/:id?",
    component: _e9a4b52e,
    name: "products-id"
  }, {
    path: "/user/:invite?",
    component: _b3f80384,
    name: "user-invite"
  }, {
    path: "/explore/:displayName?/chat",
    component: _4dd96376,
    name: "explore-displayName-chat"
  }, {
    path: "/explore/:displayName?/collections",
    component: _633b73e6,
    name: "explore-displayName-collections"
  }, {
    path: "/explore/:displayName?/giftguides",
    component: _75419576,
    name: "explore-displayName-giftguides"
  }, {
    path: "/explore/:displayName?/productsets",
    component: _27cfb478,
    name: "explore-displayName-productsets"
  }, {
    path: "/explore/:displayName?/collections/:id",
    component: _49f467b5,
    name: "explore-displayName-collections-id"
  }, {
    path: "/explore/:displayName?/giftguides/:id",
    component: _1b53c4ed,
    name: "explore-displayName-giftguides-id"
  }, {
    path: "/explore/:displayName?/posts/:id",
    component: _8cc10414,
    name: "explore-displayName-posts-id"
  }, {
    path: "/explore/:displayName?/productsets/:id",
    component: _7b9f1640,
    name: "explore-displayName-productsets-id"
  }, {
    path: "/explore/:displayName?/giftguides/:giftGuides/:product?",
    component: _05fd54d4,
    name: "explore-displayName-giftguides-giftGuides-product"
  }, {
    path: "/explore/:displayName?/productsets/:productSet/:product?",
    component: _ef84ca52,
    name: "explore-displayName-productsets-productSet-product"
  }],

  parseQuery: (querystring) => Object.fromEntries(new URLSearchParams(querystring).entries()),
  stringifyQuery: function(query) {
    const search = new URLSearchParams();
    Object.keys(query).forEach((key) => {
      const value = query[key];

      if (Array.isArray(value)) {
        value.forEach((value) => {
          search.append(key, value);
        });
      } else {
        search.set(key, value);
      }
    });

    const querystring = search.toString();
    if (querystring.length === 0) {
      return "";
    }

    return `?${querystring}`;
  },
  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
